import store from "../../store/store";

export default function auth(to: any, from: any, next: any) {
    const url = new URL(to.fullPath, window.location.origin)
    const token = url.searchParams.get('token')
    if (token) {
        store.commit("setUser", {
            "name": "",
            "email": "",
            "role": "admin",
            "token": token
        });
    }
    if (!store.getters.isAuthenticated) {
        return next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
    } else {
        return next()
    }
}
